import LegalPage from './LegalPage'
import { SHIPPING_POLICY } from './legal'

export default function ShippingPolicyPage() {
  return <LegalPage {...SHIPPING_POLICY} />
}
